var map = {
	"./action_slide_add_photo_en.png": "./src/assets/web/images/action_slide_add_photo_en.png",
	"./action_slide_add_photo_he.png": "./src/assets/web/images/action_slide_add_photo_he.png",
	"./action_slide_birthday_en.png": "./src/assets/web/images/action_slide_birthday_en.png",
	"./action_slide_birthday_he.png": "./src/assets/web/images/action_slide_birthday_he.png",
	"./action_slide_email_en.png": "./src/assets/web/images/action_slide_email_en.png",
	"./action_slide_email_he.png": "./src/assets/web/images/action_slide_email_he.png",
	"./action_slide_invite_friends_en.png": "./src/assets/web/images/action_slide_invite_friends_en.png",
	"./action_slide_invite_friends_he.png": "./src/assets/web/images/action_slide_invite_friends_he.png",
	"./action_slide_location_en.png": "./src/assets/web/images/action_slide_location_en.png",
	"./action_slide_location_he.png": "./src/assets/web/images/action_slide_location_he.png",
	"./action_slide_nickname_en.png": "./src/assets/web/images/action_slide_nickname_en.png",
	"./action_slide_nickname_he.png": "./src/assets/web/images/action_slide_nickname_he.png",
	"./action_slide_redeem_code_en.png": "./src/assets/web/images/action_slide_redeem_code_en.png",
	"./action_slide_redeem_code_he.png": "./src/assets/web/images/action_slide_redeem_code_he.png",
	"./action_slide_sign_up_en.png": "./src/assets/web/images/action_slide_sign_up_en.png",
	"./action_slide_sign_up_he.png": "./src/assets/web/images/action_slide_sign_up_he.png",
	"./action_slide_upload_new_items_en.png": "./src/assets/web/images/action_slide_upload_new_items_en.png",
	"./action_slide_upload_new_items_he.png": "./src/assets/web/images/action_slide_upload_new_items_he.png",
	"./add_name.png": "./src/assets/web/images/add_name.png",
	"./add_nickname.png": "./src/assets/web/images/add_nickname.png",
	"./add_photo.png": "./src/assets/web/images/add_photo.png",
	"./admin_avatar.png": "./src/assets/web/images/admin_avatar.png",
	"./all_button.png": "./src/assets/web/images/all_button.png",
	"./all_groups.jpg": "./src/assets/web/images/all_groups.jpg",
	"./all_you_need_to_know_in_10_secs.png": "./src/assets/web/images/all_you_need_to_know_in_10_secs.png",
	"./analytics.png": "./src/assets/web/images/analytics.png",
	"./app_store.png": "./src/assets/web/images/app_store.png",
	"./balance_background.png": "./src/assets/web/images/balance_background.png",
	"./birthday.png": "./src/assets/web/images/birthday.png",
	"./birthday_background.png": "./src/assets/web/images/birthday_background.png",
	"./boxit_logo.png": "./src/assets/web/images/boxit_logo.png",
	"./boxit_small_logo.png": "./src/assets/web/images/boxit_small_logo.png",
	"./brazil_sign_in.png": "./src/assets/web/images/brazil_sign_in.png",
	"./city_placeholder.png": "./src/assets/web/images/city_placeholder.png",
	"./coins_icon.png": "./src/assets/web/images/coins_icon.png",
	"./community_rules.png": "./src/assets/web/images/community_rules.png",
	"./confetti_background.png": "./src/assets/web/images/confetti_background.png",
	"./create_group.png": "./src/assets/web/images/create_group.png",
	"./dark_text_logo.png": "./src/assets/web/images/dark_text_logo.png",
	"./discount.png": "./src/assets/web/images/discount.png",
	"./donation.png": "./src/assets/web/images/donation.png",
	"./earn_points_banner_background.jpeg": "./src/assets/web/images/earn_points_banner_background.jpeg",
	"./email.png": "./src/assets/web/images/email.png",
	"./email_verification.png": "./src/assets/web/images/email_verification.png",
	"./empty_state_buying.png": "./src/assets/web/images/empty_state_buying.png",
	"./empty_state_buying_delivery.png": "./src/assets/web/images/empty_state_buying_delivery.png",
	"./empty_state_chats.png": "./src/assets/web/images/empty_state_chats.png",
	"./empty_state_followers.png": "./src/assets/web/images/empty_state_followers.png",
	"./empty_state_members_sold_to.png": "./src/assets/web/images/empty_state_members_sold_to.png",
	"./empty_state_my_saved_items.png": "./src/assets/web/images/empty_state_my_saved_items.png",
	"./empty_state_notifications.png": "./src/assets/web/images/empty_state_notifications.png",
	"./empty_state_search.png": "./src/assets/web/images/empty_state_search.png",
	"./empty_state_selling.png": "./src/assets/web/images/empty_state_selling.png",
	"./empty_state_selling_delivery.png": "./src/assets/web/images/empty_state_selling_delivery.png",
	"./empty_state_wish_fulfillment.png": "./src/assets/web/images/empty_state_wish_fulfillment.png",
	"./empty_state_your_items_for_sale.png": "./src/assets/web/images/empty_state_your_items_for_sale.png",
	"./empty_state_your_items_purchased.png": "./src/assets/web/images/empty_state_your_items_purchased.png",
	"./empty_state_your_items_sold.png": "./src/assets/web/images/empty_state_your_items_sold.png",
	"./empty_state_your_items_wishes.png": "./src/assets/web/images/empty_state_your_items_wishes.png",
	"./endorsements_big.png": "./src/assets/web/images/endorsements_big.png",
	"./endorsments.png": "./src/assets/web/images/endorsments.png",
	"./eng_sign_in.png": "./src/assets/web/images/eng_sign_in.png",
	"./expense_tokens.png": "./src/assets/web/images/expense_tokens.png",
	"./explore_near_home.png": "./src/assets/web/images/explore_near_home.png",
	"./explore_nearby.png": "./src/assets/web/images/explore_nearby.png",
	"./faq.png": "./src/assets/web/images/faq.png",
	"./force_update.png": "./src/assets/web/images/force_update.png",
	"./forest_icon.png": "./src/assets/web/images/forest_icon.png",
	"./fulfil_wish_banner.png": "./src/assets/web/images/fulfil_wish_banner.png",
	"./gender.png": "./src/assets/web/images/gender.png",
	"./german_sign_in.png": "./src/assets/web/images/german_sign_in.png",
	"./gift.png": "./src/assets/web/images/gift.png",
	"./google_play.png": "./src/assets/web/images/google_play.png",
	"./group_background_placeholder.png": "./src/assets/web/images/group_background_placeholder.png",
	"./heb_sign_in.png": "./src/assets/web/images/heb_sign_in.png",
	"./income_tokens.png": "./src/assets/web/images/income_tokens.png",
	"./invite_friends_background.png": "./src/assets/web/images/invite_friends_background.png",
	"./invite_friends_banner.png": "./src/assets/web/images/invite_friends_banner.png",
	"./invite_friends_page.png": "./src/assets/web/images/invite_friends_page.png",
	"./item_avatar_placeholder.png": "./src/assets/web/images/item_avatar_placeholder.png",
	"./logo.png": "./src/assets/web/images/logo.png",
	"./logo_with_slogan.png": "./src/assets/web/images/logo_with_slogan.png",
	"./low_res_logo.png": "./src/assets/web/images/low_res_logo.png",
	"./map_marker.png": "./src/assets/web/images/map_marker.png",
	"./marketplace_banner_background.jpeg": "./src/assets/web/images/marketplace_banner_background.jpeg",
	"./members_sold_to.png": "./src/assets/web/images/members_sold_to.png",
	"./money_bag.png": "./src/assets/web/images/money_bag.png",
	"./no_internet_connection.png": "./src/assets/web/images/no_internet_connection.png",
	"./not_verified_account.png": "./src/assets/web/images/not_verified_account.png",
	"./onboarding_1.png": "./src/assets/web/images/onboarding_1.png",
	"./onboarding_2.png": "./src/assets/web/images/onboarding_2.png",
	"./onboarding_3.png": "./src/assets/web/images/onboarding_3.png",
	"./owl_security.png": "./src/assets/web/images/owl_security.png",
	"./people_icon.png": "./src/assets/web/images/people_icon.png",
	"./phone.png": "./src/assets/web/images/phone.png",
	"./presents.png": "./src/assets/web/images/presents.png",
	"./price.png": "./src/assets/web/images/price.png",
	"./primary_location.png": "./src/assets/web/images/primary_location.png",
	"./profile.png": "./src/assets/web/images/profile.png",
	"./profile_1.png": "./src/assets/web/images/profile_1.png",
	"./promo_code.png": "./src/assets/web/images/promo_code.png",
	"./promo_code_small.png": "./src/assets/web/images/promo_code_small.png",
	"./rewards_wallet_background.png": "./src/assets/web/images/rewards_wallet_background.png",
	"./round_logo.png": "./src/assets/web/images/round_logo.png",
	"./rules.png": "./src/assets/web/images/rules.png",
	"./search.png": "./src/assets/web/images/search.png",
	"./select_token_icon.png": "./src/assets/web/images/select_token_icon.png",
	"./shadow.png": "./src/assets/web/images/shadow.png",
	"./shipping.png": "./src/assets/web/images/shipping.png",
	"./splash_logo.png": "./src/assets/web/images/splash_logo.png",
	"./tex_log_white.png": "./src/assets/web/images/tex_log_white.png",
	"./text_logo.png": "./src/assets/web/images/text_logo.png",
	"./tokens.png": "./src/assets/web/images/tokens.png",
	"./university.png": "./src/assets/web/images/university.png",
	"./user_avatar_placeholder.png": "./src/assets/web/images/user_avatar_placeholder.png",
	"./user_map_marker.png": "./src/assets/web/images/user_map_marker.png",
	"./verification_code.png": "./src/assets/web/images/verification_code.png",
	"./verified_account.png": "./src/assets/web/images/verified_account.png",
	"./wallet_background.png": "./src/assets/web/images/wallet_background.png",
	"./wallet_background_big.png": "./src/assets/web/images/wallet_background_big.png",
	"./welcome.png": "./src/assets/web/images/welcome.png",
	"./welcome_small.png": "./src/assets/web/images/welcome_small.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/web/images sync recursive ^\\.\\/.*$";